export default "__VITE_PUBLIC_ASSET__8c2ce404__"